module.exports = __webpack_public_path__ + "img/panasonic.00c1599.png";